(function () {
  'use strict';

  var root = document.querySelector('[data-ask-venucast-root]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  root.hidden = false;

  var floatingButton = root.querySelector('[data-ask-open]');
  var drawer = root.querySelector('[data-ask-drawer]');
  var form = root.querySelector('[data-ask-form]');
  var input = root.querySelector('[data-ask-input]');
  var sendButton = root.querySelector('[data-ask-send]');
  var micButton = root.querySelector('[data-ask-mic]');
  var voiceStatus = root.querySelector('[data-ask-voice-status]');
  var messages = root.querySelector('[data-ask-messages]');
  var resultHost = root.querySelector('[data-ask-result]');
  var restartButton = root.querySelector('[data-ask-restart]');
  var expertLink = root.querySelector('[data-ask-expert]');
  var lastFocused = null;
  var state = freshState();
  var conversationHistory = [];
  var requestInFlight = false;
  var requestController = null;
  var floatingDrag = { active: false, moved: false, pointerId: null, startX: 0, startY: 0, left: 0, top: 0, width: 0, height: 0, threshold: 5 };
  var suppressFloatingClick = false;
  var speech = createSpeechAdapter();

  function freshState() {
    return { attemptId: uuid() };
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var random = Math.floor(Math.random() * 16);
      return (character === 'x' ? random : (random & 3) | 8).toString(16);
    });
  }

  function pagePath() {
    var path = root.dataset.pagePath || window.location.pathname || '/';
    return path.charAt(0) === '/' ? path.slice(0, 300) : '/';
  }

  function sendEvent(name, properties, beacon) {
    var payload = Object.assign({
      event_id: uuid(),
      event: name,
      finder_version: 'ask-venucast-gpt-native-2026-09-08-v1',
      attempt_id: state.attemptId,
      event_time: new Date().toISOString(),
      page_path: pagePath(),
      current_step: 1,
      current_question: 'unknown'
    }, properties || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    var endpoint = root.dataset.logEndpoint;
    if (!endpoint) return;
    var body = JSON.stringify(payload);
    if (beacon && navigator.sendBeacon) {
      navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      return;
    }
    fetch(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true, headers: { 'content-type': 'text/plain;charset=UTF-8' }, body: body }).catch(function () {});
  }

  function openDrawer() {
    if (root.dataset.open === 'true') return;
    lastFocused = document.activeElement;
    root.dataset.open = 'true';
    document.body.classList.add('ask-venucast-open');
    drawer.focus();
    sendEvent('ask_venucast_opened', { start_source: conversationHistory.length ? 'resume' : 'floating_widget' });
  }

  function closeDrawer() {
    if (root.dataset.open !== 'true') return;
    sendEvent('ask_venucast_closed', { completed: conversationHistory.length ? 'yes' : 'no' }, true);
    root.dataset.open = 'false';
    document.body.classList.remove('ask-venucast-open');
    speech.stop();
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function clamp(value, minimum, maximum) {
    return Math.min(Math.max(value, minimum), Math.max(minimum, maximum));
  }

  function startFloatingDrag(event) {
    if (floatingDrag.active || event.isPrimary === false) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    var rect = floatingButton.getBoundingClientRect();
    floatingDrag.active = true;
    floatingDrag.moved = false;
    floatingDrag.pointerId = event.pointerId;
    floatingDrag.startX = event.clientX;
    floatingDrag.startY = event.clientY;
    floatingDrag.left = rect.left;
    floatingDrag.top = rect.top;
    floatingDrag.width = rect.width;
    floatingDrag.height = rect.height;
    floatingDrag.threshold = event.pointerType === 'mouse' ? 5 : 10;
    if (floatingButton.setPointerCapture) floatingButton.setPointerCapture(event.pointerId);
    floatingButton.dataset.dragging = 'true';
  }

  function moveFloatingButton(event) {
    if (!floatingDrag.active || event.pointerId !== floatingDrag.pointerId) return;
    var deltaX = event.clientX - floatingDrag.startX;
    var deltaY = event.clientY - floatingDrag.startY;
    if (!floatingDrag.moved && Math.hypot(deltaX, deltaY) < floatingDrag.threshold) return;
    floatingDrag.moved = true;
    event.preventDefault();
    var gap = 8;
    floatingButton.style.left = clamp(floatingDrag.left + deltaX, gap, window.innerWidth - floatingDrag.width - gap) + 'px';
    floatingButton.style.top = clamp(floatingDrag.top + deltaY, gap, window.innerHeight - floatingDrag.height - gap) + 'px';
    floatingButton.style.right = 'auto';
    floatingButton.style.bottom = 'auto';
    floatingButton.style.transform = 'none';
    floatingButton.dataset.dragged = 'true';
  }

  function finishFloatingDrag(event) {
    if (!floatingDrag.active || event.pointerId !== floatingDrag.pointerId) return;
    if (event.type === 'pointerup' && floatingDrag.moved) suppressFloatingClick = true;
    if (floatingButton.hasPointerCapture && floatingButton.hasPointerCapture(event.pointerId)) floatingButton.releasePointerCapture(event.pointerId);
    floatingDrag.active = false;
    floatingDrag.pointerId = null;
    delete floatingButton.dataset.dragging;
  }

  function keepFloatingButtonInView() {
    if (floatingButton.dataset.dragged !== 'true') return;
    var rect = floatingButton.getBoundingClientRect();
    var gap = 8;
    floatingButton.style.left = clamp(rect.left, gap, window.innerWidth - rect.width - gap) + 'px';
    floatingButton.style.top = clamp(rect.top, gap, window.innerHeight - rect.height - gap) + 'px';
  }

  function handleFloatingClick(event) {
    if (suppressFloatingClick) {
      event.preventDefault();
      suppressFloatingClick = false;
      return;
    }
    openDrawer();
  }

  function appendAnswerText(item, text) {
    // Render only HTTP(S) links; all model-provided text stays out of innerHTML.
    var content = String(text || '').trim();
    // Separate the shipping conclusion from its delivery estimate.
    content = content.replace(/([.!?]) +(Estimated delivery\b)/g, '$1\n\n$2');
    var links = /\[([^\]\n]+)\]\((https?:\/\/[^\s<>"`]+)\)|https?:\/\/[^\s<>"`]+/gi;
    var cursor = 0;
    var match;
    while ((match = links.exec(content))) {
      var href = match[2] || match[0];
      if (!match[2]) {
        href = href.replace(/[.,!?;:，。！？；：]+$/, '');
        // Exclude surrounding punctuation but retain balanced URL parentheses.
        while (/[)\]}]$/.test(href)) {
          var close = href.slice(-1);
          var open = { ')': '(', ']': '[', '}': '{' }[close];
          if (href.split(close).length <= href.split(open).length) break;
          href = href.slice(0, -1);
        }
      }
      var valid = false;
      try {
        var url = new URL(href);
        valid = (url.protocol === 'https:' || url.protocol === 'http:') && !url.username && !url.password;
      } catch (error) {}
      if (!valid) continue;
      item.appendChild(document.createTextNode(content.slice(cursor, match.index)));
      var link = document.createElement('a');
      link.href = href;
      link.textContent = match[1] || (/^https:\/\/(?:www\.)?venucast\.com\/pages\/shipping-details\/?(?:[?#].*)?$/i.test(href) ? 'Shipping details' : href);
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      item.appendChild(link);
      cursor = match.index + (match[2] ? match[0].length : href.length);
    }
    item.appendChild(document.createTextNode(content.slice(cursor)));
  }

  function createMessage(type, text, remember) {
    var item = document.createElement('div');
    item.className = 'ask-venucast__message ask-venucast__message--' + type;
    if (type === 'assistant') appendAnswerText(item, text);
    else item.textContent = text;
    messages.appendChild(item);
    if (remember !== false) conversationHistory.push({ role: type === 'customer' ? 'customer' : 'assistant', text: text });
    scrollToLatest();
    return item;
  }

  function scrollToLatest() {
    window.requestAnimationFrame(function () {
      var body = root.querySelector('[data-ask-content]');
      body.scrollTop = body.scrollHeight;
    });
  }

  function currentPageContext() {
    var heading = document.querySelector('main h1, [role="main"] h1, h1');
    var description = document.querySelector('[data-product-description], .product__description, .product-description');
    var visibleDescription = description && description.textContent ? description.textContent.replace(/\s+/g, ' ').trim().slice(0, 1600) : '';
    return {
      page_url: window.location.href,
      page_title: document.title,
      page_type: root.dataset.pageType || '',
      page_h1: heading && heading.textContent ? heading.textContent.trim().slice(0, 300) : root.dataset.productName || '',
      product_handle: root.dataset.productHandle || null,
      product_name: root.dataset.productName || null,
      product_sku: root.dataset.productSku || null,
      visible_page_context: visibleDescription || null
    };
  }

  function submitQuestion(rawText) {
    var text = rawText.trim();
    if (!text || requestInFlight) return;
    sendEvent('ask_venucast_text_submitted', { cta_type: 'text_input', input_length: String(text.length) });
    createMessage('customer', text);
    askNative(text);
  }

  function askNative(question) {
    var endpoint = root.dataset.guidanceEndpoint;
    if (!endpoint) {
      createMessage('assistant', root.dataset.guidanceUnavailable);
      return;
    }
    requestInFlight = true;
    setComposerBusy(true);
    requestController = typeof AbortController === 'function' ? new AbortController() : null;
    var sessionId = state.attemptId;
    var context = currentPageContext();
    fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'content-type': 'application/json' },
      signal: requestController ? requestController.signal : undefined,
      body: JSON.stringify({
        brand: 'venucast',
        experience_name: 'ask_venucast',
        session_id: state.attemptId,
        visitor_id: state.attemptId,
        question: question,
        question_event_id: uuid(),
        response_event_id: uuid(),
        conversation_history: conversationHistory,
        page_url: context.page_url,
        page_title: context.page_title,
        page_type: context.page_type,
        page_h1: context.page_h1,
        product_handle: context.product_handle,
        product_name: context.product_name,
        product_sku: context.product_sku,
        visible_page_context: context.visible_page_context,
        locale: document.documentElement.lang || 'en-US'
      })
    }).then(function (response) {
      return response.json().then(function (result) {
        if (!response.ok && !(result && result.answer)) throw new Error('ask_venucast_unavailable');
        return result;
      });
    }).then(function (result) {
      if (state.attemptId !== sessionId) return;
      createMessage('assistant', result && result.answer ? result.answer : root.dataset.guidanceUnavailable);
      if (result && result.escalation_required) showFollowUpForm();
    }).catch(function (error) {
      if (error && error.name === 'AbortError') return;
      if (state.attemptId === sessionId) createMessage('assistant', root.dataset.guidanceUnavailable);
    }).finally(function () {
      if (state.attemptId !== sessionId) return;
      requestInFlight = false;
      requestController = null;
      setComposerBusy(false);
      input.focus();
    });
  }

  function setComposerBusy(busy) {
    input.disabled = busy;
    micButton.disabled = busy || !speech.available;
    sendButton.disabled = busy || !input.value.trim();
    drawer.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function showFollowUpForm() {
    if (resultHost.querySelector('[data-ask-followup]') || !root.dataset.followupUrl) return;
    resultHost.hidden = false;
    var followUp = document.createElement('form');
    followUp.className = 'ask-venucast__followup';
    followUp.dataset.askFollowup = 'true';
    var title = document.createElement('strong'); title.textContent = root.dataset.followupTitle; followUp.appendChild(title);
    var copy = document.createElement('p'); copy.textContent = root.dataset.followupCopy; followUp.appendChild(copy);
    var email = document.createElement('input'); email.type = 'email'; email.required = true; email.autocomplete = 'email'; email.placeholder = root.dataset.followupEmail; email.setAttribute('aria-label', root.dataset.followupEmail); followUp.appendChild(email);
    var consentLabel = document.createElement('label'); consentLabel.className = 'ask-venucast__followup-consent';
    var consent = document.createElement('input'); consent.type = 'checkbox'; consent.required = true; consentLabel.appendChild(consent);
    consentLabel.appendChild(document.createTextNode(root.dataset.followupConsent)); followUp.appendChild(consentLabel);
    var submit = document.createElement('button'); submit.type = 'submit'; submit.textContent = root.dataset.followupSubmit; followUp.appendChild(submit);
    var status = document.createElement('p'); status.className = 'ask-venucast__followup-status'; status.setAttribute('aria-live', 'polite'); followUp.appendChild(status);
    followUp.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!followUp.reportValidity()) return;
      submit.disabled = true;
      status.textContent = root.dataset.followupSending;
      fetch(root.dataset.followupUrl, {
        method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ session_id: state.attemptId, email: email.value, consent: consent.checked, brand: 'venucast', experience_name: 'ask_venucast' })
      }).then(function (response) {
        if (!response.ok) throw new Error('followup_failed');
        return response.json();
      }).then(function () {
        email.disabled = true; consent.disabled = true; submit.hidden = true;
        status.textContent = root.dataset.followupSuccess;
        sendEvent('ask_venucast_cta_clicked', { cta_type: 'email_followup_requested' });
      }).catch(function () {
        submit.disabled = false;
        status.textContent = root.dataset.followupError;
      });
    });
    resultHost.appendChild(followUp);
    scrollToLatest();
  }

  function resetConversation(shouldLog) {
    if (shouldLog) sendEvent('ask_venucast_restarted');
    if (requestController) requestController.abort();
    state = freshState();
    conversationHistory = [];
    requestInFlight = false;
    requestController = null;
    resultHost.hidden = true;
    resultHost.textContent = '';
    messages.textContent = '';
    createMessage('assistant', root.dataset.restarted, false);
    input.value = '';
    sendButton.disabled = true;
    resizeInput();
    input.focus();
  }

  function resizeInput() {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 116) + 'px';
  }

  function createSpeechAdapter() {
    var Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    var recognition = Recognition ? new Recognition() : null;
    var listening = false;
    if (!recognition) {
      micButton.disabled = true;
      micButton.title = root.dataset.voiceUnavailableText;
      voiceStatus.textContent = root.dataset.voiceUnavailableText;
      return { available: false, start: function () {}, stop: function () {} };
    }
    recognition.lang = document.documentElement.lang || 'en-US';
    recognition.interimResults = true;
    recognition.continuous = false;
    recognition.onstart = function () {
      listening = true;
      micButton.dataset.listening = 'true';
      voiceStatus.textContent = root.dataset.listeningText;
    };
    recognition.onresult = function (event) {
      var transcript = '';
      for (var index = event.resultIndex; index < event.results.length; index += 1) transcript += event.results[index][0].transcript;
      input.value = transcript.trim();
      sendButton.disabled = !input.value;
      resizeInput();
    };
    recognition.onerror = function () { voiceStatus.textContent = root.dataset.voiceErrorText; };
    recognition.onend = function () {
      listening = false;
      micButton.dataset.listening = 'false';
      if (input.value) { voiceStatus.textContent = ''; input.focus(); }
    };
    return {
      available: true,
      start: function () {
        if (listening) { recognition.stop(); return; }
        sendEvent('ask_venucast_voice_used', { cta_type: 'voice_input' });
        recognition.start();
      },
      stop: function () { if (listening) recognition.stop(); }
    };
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var text = input.value;
    if (!text.trim() || requestInFlight) return;
    input.value = '';
    resizeInput();
    submitQuestion(text);
  });
  input.addEventListener('input', function () {
    sendButton.disabled = requestInFlight || !input.value.trim();
    resizeInput();
  });
  input.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (!sendButton.disabled) form.requestSubmit();
    }
  });
  micButton.addEventListener('click', function () { speech.start(); });
  restartButton.addEventListener('click', function () { resetConversation(true); });
  expertLink.addEventListener('click', function () { sendEvent('ask_venucast_cta_clicked', { cta_type: 'ask_expert' }, true); });
  root.querySelectorAll('[data-ask-close]').forEach(function (button) { button.addEventListener('click', closeDrawer); });
  floatingButton.addEventListener('pointerdown', startFloatingDrag);
  floatingButton.addEventListener('pointermove', moveFloatingButton);
  floatingButton.addEventListener('pointerup', finishFloatingDrag);
  floatingButton.addEventListener('pointercancel', finishFloatingDrag);
  floatingButton.addEventListener('click', handleFloatingClick);
  window.addEventListener('resize', keepFloatingButtonInView);
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && root.dataset.open === 'true') closeDrawer(); });
})();
